import { logUsage } from 'owa-analytics';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import TypeOfAttachment from 'owa-attachment-model-store/lib/store/schema/TypeOfAttachment';
import { ClientAttachmentId } from 'owa-client-ids';
import { getExtensionWithoutDotFromFileNameForLogging } from 'owa-file';

// IMPORTANT: If you add another enum value here then make sure to add a corresponding
// datapoint in the datapointMap below
export const enum WacDatapointType {
    WacEdit,
    WacEditAndReply,
}

const datapointMap: { [key: number]: string } = Object.freeze({
    [WacDatapointType.WacEdit]: 'WacEdit',
    [WacDatapointType.WacEditAndReply]: 'WacEditAndReply',
});

export default function logWacDatapoint(
    attachmentId: ClientAttachmentId,
    wacDatapointType: WacDatapointType,
    actionSource: string
) {
    const attachment = getAttachment(attachmentId);
    if (!attachment) {
        return;
    }
    const fileType =
        getExtensionWithoutDotFromFileNameForLogging(attachment.model.Name || '') ||
        attachment.model.ContentType ||
        '';

    logUsage(datapointMap[wacDatapointType], [
        fileType,
        attachment.type === TypeOfAttachment.Reference ? 'cloudy' : 'classic',
    ]);
}
